import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  
  static targets = ["button"]

  progress(event) {
    this.buttonTarget.disabled = true;
    this.buttonTarget.classList.add("loading");
  }
  
}
